import { Injectable } from '@angular/core';

import { tap, Observable, switchMap } from 'rxjs';

import { WebSocketEventsEnum } from '@shared/websocket';
import { PlanTier } from '@shared/price-plan/enums';
import { PricePlan } from '@shared/price-plan/models';
import { PricePlansQuery, PricePlansStore } from '../states';
import { PricePlansApiService } from './price-plans-api.service';
import { SocketService } from './socket.service';

@Injectable({ providedIn: 'root' })
export class PricePlansQueryService {
  constructor(
    private readonly store: PricePlansStore,
    private readonly query: PricePlansQuery,
    private readonly socketService: SocketService,
    private readonly pricePlansApiService: PricePlansApiService,
  ) {}

  load(): Observable<PricePlan[]> {
    return this.pricePlansApiService.get()
      .pipe(tap(pricePlans => this.store.set(pricePlans)));
  }

  selectAll(): Observable<PricePlan[]> {
    return this.query.selectAll();
  }

  getAll(): PricePlan[] {
    return this.query.getAll();
  }

  getByTier(tier: PlanTier): PricePlan[] {
    return this.query.getAll().filter(plan => plan.tier === tier);
  }

  getFreePlan(): PricePlan {
    return this.query.getAll().find(plan => plan.tier === PlanTier.free) as PricePlan;
  }

  getByPlanCode(code: string): PricePlan | undefined {
    return this.query.getAll().find(plan => plan.plan_code === code);
  }

  listenToChanges(): Observable<PricePlan[]> {
    return this.socketService.getEventStream<PricePlan[]>(WebSocketEventsEnum.pricePlansUpdated)
      .pipe(switchMap(() => this.load()));
  }
}
